import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "flex w-full items-center mb-12" }
const _hoisted_3 = { class: "mb-0 ml-2 mr-auto" }
const _hoisted_4 = {
  key: 1,
  class: "flex space-x-3 items-center"
}
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = {
  key: 2,
  class: "ml-2"
}
const _hoisted_7 = { class: "mb-8 flex items-center space-x-8" }
const _hoisted_8 = { class: "w-1/3" }
const _hoisted_9 = { class: "error-msg" }
const _hoisted_10 = { class: "mt-8" }
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons opacity-60",
  style: {"font-size":"20px !important"}
}, " radio_button_checked ", -1)
const _hoisted_14 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_15 = { class: "mr-4 ml-1" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "edit", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "delete", -1)
const _hoisted_18 = {
  key: 1,
  class: "flex w-full items-center space-x-2"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, "done", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, "close", -1)
const _hoisted_21 = {
  key: 0,
  class: "mt-4 flex w-full items-center space-x-1"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons opacity-60",
  style: {"font-size":"20px !important"}
}, " radio_button_checked ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, "done", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "close", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 text-base material-icons-outlined" }, " add ", -1)
const _hoisted_26 = { class: "error-msg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_CloudSaveStatus = _resolveComponent("CloudSaveStatus")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_TextEditor = _resolveComponent("TextEditor")!
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Btn, {
        variant: 'icon',
        outline: true,
        class: "-ml-2"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: "material-icons-outlined",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeEditor')))
          }, " close")
        ]),
        _: 1
      }),
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("course_tree.poll_editor_title")), 1),
      (_ctx.showAutoSaveIndicator)
        ? (_openBlock(), _createBlock(_component_CloudSaveStatus, {
            key: 0,
            saving: _ctx.saving,
            hadError: _ctx.savingError,
            class: "mt-1 mr-6"
          }, null, 8, ["saving", "hadError"]))
        : _createCommentVNode("", true),
      (_ctx.modelValue.state === _ctx.PollNodeState.DRAFT)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("course_tree.draft")), 1),
            _createVNode(_component_Btn, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPublish()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("course_tree.publish_poll")), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.autoSave)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_Btn, {
              disabled: _ctx.blockingSaving,
              outline: _ctx.modelValue.state === _ctx.PollNodeState.DRAFT,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSave()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.modelValue.state === _ctx.PollNodeState.DRAFT
							? _ctx.$t("course_tree.save_draft")
							: _ctx.$t("course_tree.save")), 1)
              ]),
              _: 1
            }, 8, ["disabled", "outline"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Dropdown, {
          loading: _ctx.loadingTopics,
          options: _ctx.topicsAsOptions,
          modelValue: _ctx.modelValue.parent_id,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.onParentChange($event)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("course_tree.topic_label")), 1)
          ]),
          _: 1
        }, 8, ["loading", "options", "modelValue"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_TextEditor, {
        modelValue: _ctx.modelValue.text,
        fixedLabel: true,
        onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onBlur())),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.onNodeChange('text', $event)))
      }, _createSlots({
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("course_tree.poll_text")) + " ", 1)
        ]),
        _: 2
      }, [
        (_ctx.v$.modelValue.text.$errors.length > 0)
          ? {
              name: "errors",
              fn: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.modelValue.text.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "input-errors",
                    key: error.$uid
                  }, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("validation_errors.course_tree.poll." + error.$uid)), 1)
                  ]))
                }), 128))
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t("course_tree.poll_choices")), 1),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue.choices, (choice) => {
          return (_openBlock(), _createElementBlock("div", {
            key: choice.id,
            class: _normalizeClass(["flex items-center space-x-1 my-0.5 group transition-colors duration-100 ease-in-out rounded-sm", { 'hover:bg-light': _ctx.editingChoice?.id !== choice.id }])
          }, [
            _hoisted_13,
            (_ctx.editingChoice?.id !== choice.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("p", _hoisted_15, _toDisplayString(choice.text), 1),
                  _createVNode(_component_Btn, {
                    class: "opacity-0 group-hover:opacity-80 duration-100 transition-opacity ease-in-out",
                    onClick: ($event: any) => (_ctx.onEditChoice(choice)),
                    variant: 'icon',
                    outline: true
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (_ctx.modelValue.choices.length > 1)
                    ? (_openBlock(), _createBlock(_component_Btn, {
                        key: 0,
                        class: "opacity-0 group-hover:opacity-80 duration-100 transition-opacity ease-in-out",
                        onClick: ($event: any) => (_ctx.onDeleteChoice(choice)),
                        variant: 'icon',
                        outline: true
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_TextInput, {
                    onKeyup: _withKeys(_ctx.onSaveChoice, ["enter"]),
                    class: "w-full",
                    modelValue: _ctx.editingChoice.text,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editingChoice.text) = $event))
                  }, null, 8, ["onKeyup", "modelValue"]),
                  _createVNode(_component_Btn, {
                    disabled: _ctx.editingChoice.text.trim().length === 0,
                    onClick: _ctx.onSaveChoice,
                    variant: 'icon',
                    outline: true
                  }, {
                    default: _withCtx(() => [
                      _hoisted_19
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]),
                  _createVNode(_component_Btn, {
                    onClick: _ctx.onDiscardChoice,
                    variant: 'icon',
                    outline: true
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
          ], 2))
        }), 128)),
        (_ctx.editingChoice?.id === '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_TextInput, {
                class: "w-full",
                onKeyup: _withKeys(_ctx.onSaveChoice, ["enter"]),
                modelValue: _ctx.editingChoice.text,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editingChoice.text) = $event)),
                placeholder: _ctx.$t('course_tree.poll_choice_text')
              }, null, 8, ["onKeyup", "modelValue", "placeholder"]),
              _createVNode(_component_Btn, {
                disabled: _ctx.editingChoice.text.trim().length === 0,
                onClick: _ctx.onSaveChoice,
                variant: 'icon',
                outline: true,
                class: "my-auto"
              }, {
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_Btn, {
                class: "my-auto",
                onClick: _ctx.onDiscardChoice,
                variant: 'icon',
                outline: true
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : (_openBlock(), _createBlock(_component_Btn, {
              key: 1,
              class: "mt-4 w-max",
              variant: 'secondary',
              size: 'sm',
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onCreateChoice()))
            }, {
              default: _withCtx(() => [
                _hoisted_25,
                _createTextVNode(_toDisplayString(_ctx.$t("course_tree.new_poll_choice")), 1)
              ]),
              _: 1
            }))
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.modelValue.choices.$errors, (error) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "input-errors",
        key: error.$uid
      }, [
        _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("validation_errors.course_tree.poll." + error.$uid)), 1)
      ]))
    }), 128))
  ]))
}